import cn from 'classnames';

import { IconDownChevron } from './Icons';

// TODO: type props
export function Table(props: any) {
  return (
    <div className="w-full overflow-hidden">
      <div className="relative overflow-auto">
        <table {...props} />
      </div>
    </div>
  );
}

interface PaginationProps {
  pageCount: number;
  pageIndex: number;
  className: string;
  gotoPage: (page: number) => void;
  previousPage: () => void;
  nextPage: () => void;
  canPreviousPage: boolean;
  canNextPage: boolean;
}

export function Pagination({
  className,
  pageCount,
  pageIndex,
  gotoPage,
  canPreviousPage,
  canNextPage,
  previousPage,
  nextPage,
}: PaginationProps) {
  const paginationIndices = boundedRange(createRange(pageCount), pageIndex, 2);

  return (
    <div className={className}>
      <nav className="relative z-0 inline-flex shadow-sm -space-x-px" aria-label="Pagination">
        <button
          type="button"
          className="relative inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-l-md hover:bg-gray-50"
          onClick={() => gotoPage(0)}
          disabled={!canPreviousPage}
        >
          <IconDownChevron className="transform rotate-90 h-5 w-5 -mr-3.5" />
          <IconDownChevron className="w-5 h-5 transform rotate-90" />
        </button>
        <button
          type="button"
          className="relative inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 hover:bg-gray-50"
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          <IconDownChevron className="w-5 h-5 transform rotate-90" />
        </button>
        {!paginationIndices.includes(0) && (
          <span className="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300">
            ...
          </span>
        )}
        {paginationIndices.map((index) => (
          <button
            type="button"
            key={index}
            className={cn(
              'relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50',
              {
                'text-blue-500 font-bold': index === pageIndex,
                'text-gray-700': index !== pageIndex,
              },
            )}
            onClick={() => gotoPage(index)}
          >
            {index + 1}
          </button>
        ))}
        {!paginationIndices.includes(pageCount - 1) && (
          <span className="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300">
            ...
          </span>
        )}
        <button
          type="button"
          className="relative inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 hover:bg-gray-50"
          onClick={() => nextPage()}
          disabled={!canNextPage}
        >
          <IconDownChevron className="w-5 h-5 transform -rotate-90" />
        </button>
        <button
          type="button"
          className="relative inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-r-md hover:bg-gray-50"
          onClick={() => gotoPage(pageCount - 1)}
          disabled={!canNextPage}
        >
          <IconDownChevron className="transform -rotate-90 h-5 w-5 -mr-3.5" />
          <IconDownChevron className="w-5 h-5 transform -rotate-90" />
        </button>
      </nav>
    </div>
  );
}

function createRange(num: number): Array<number> {
  return new Array(num).fill(0).map((_, i) => i);
}

function boundedRange<T>(array: Array<T>, targetIndex: number, rangeBuffer: number): Array<T> {
  if (targetIndex - rangeBuffer < 0) return array.slice(0, 2 * rangeBuffer + 1);
  if (targetIndex + rangeBuffer > array.length - 1) return array.slice(-1 * (2 * rangeBuffer + 1));
  return array.slice(targetIndex - rangeBuffer, targetIndex + rangeBuffer + 1);
}
